
import { SWRConfiguration, SWRResponse } from "swr";

import { GetInstitutionNotes, GetNotesResponse, UpdatedNoteEvent } from "@/api/dtos";
import { AppSettings } from "@/AppSettings";
import useGet from "@/hooks/api/useGet";
import { HubConnection } from "@microsoft/signalr/dist/esm";
import { useCallback, useMemo } from "react";
import useSignalROnMessage from "../api/useSignalROnMessage";

const getData = (response?: SWRResponse<GetNotesResponse, GetNotesResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<GetNotesResponse, GetNotesResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetNotesResponse, GetNotesResponse>) => ({});

export const useInstitutionNotesAndQueries = (institutionId?: number, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!institutionId) {
            return undefined;
        }

        return () => {
            return new GetInstitutionNotes({ institutionId });
        }
    }, [institutionId]);

    const output = useGet(request, { getData, getError, getAdditionalState }, configuration);

    const onMessage = useCallback(async (connection: HubConnection, data: UpdatedNoteEvent) => {
        if (
            institutionId === data.institutionId
        )
        {
            await output.refresh();
        }

    }, [
        output.refresh, 
        institutionId
    ]);

    useSignalROnMessage(AppSettings.channels.note, onMessage);

    return output;
}

export default useInstitutionNotesAndQueries;